module.exports = __webpack_public_path__ + "img/17.8114164b.jpg";